module.exports = __webpack_public_path__ + "img/icon2.668c0c9e.png";